module.exports = __webpack_public_path__ + "assets/progress.143ca106.svg";